import { useState } from "react";
import { UserScopeEntity } from "../../../../../entities/ServicesEntities/UserEntities/UserScopeEntity";
import {
  ADD_PARKER_FORM_STEPS
} from "../../../../../enums/Enums";
import { commonActions } from "../../../../../redux/reducers/CommonReducer";
import { userActions } from "../../../../../redux/reducers/UserReducer";
import store from "../../../../../redux/Store";
import Strings from "../../../../../resources/Strings";
import * as userScopesActionsService from "../../../../../services/ActionsService/UserScopesActionsService";
import {
  showErrorMessage,
  showUpdateSuccessMessage,
} from "../../../../../utils/MessagesUtils";
import EllipseButton from "../../../Buttons/EllipseButton/EllipseButton";
import UserRoleStep from "../Steps/UserRoleStep";
import classes from "../WizardForm.module.css";
import { useSelector } from "react-redux";

const AddPermissionsForm = (props) => {
  const currentScope = useSelector((state) => state.user.selectedSite?.scopeId);
  const currentUsersScopes = useSelector((state) => state.user.currentUsersScopes); // added
  const [formData, setFormData] = useState({
    userScopes: props?.userData?.userScopes,
    scopesList: props?.isEditMode ? currentUsersScopes : currentUsersScopes?.filter(scope => !props?.userData?.userScopes?.some(us => scope.id === us.scopeId)),
    role: props?.isEditMode
      ? props?.userData?.userScopes.find(
          (scope) => scope.scopeId === props?.userData?.scope?.id
        )?.role?.id
      : "",
    scope:  props?.isEditMode
    ? props?.userData?.userScopes.find(
        (scope) => scope.scopeId === props?.userData?.scope?.id
      )?.scope
    : currentUsersScopes?.filter(scope => !props?.userData?.userScopes?.some(us => scope.id === us.scopeId))[0]
    //scope: props?.userData?.selectedScopeId,
  });

  const [stateData, setStateData] = useState({
    currentStep: ADD_PARKER_FORM_STEPS.ADD_PERMISSIONS,
    totalSteps: 1,
    isCurrentStepValid: false,
  });

  const handleChange = (newProp) => {
    setFormData({ ...formData, ...newProp });
  };

  const handleCurrentStepValidity = (hasError) => {
    setStateData({ ...stateData, isCurrentStepValid: !hasError });
  };
  const isRoleAlreadyExist = (scope) => {
    if (props.userScopes?.find(userScope => userScope.scopeId === scope.id)?.roleId) {
      return true;
    }
    return false;
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    setFormData({ ...formData, ["isStepSubmitted"]: true });
    const { role, scope } = formData;

    if (stateData.isCurrentStepValid) {
      let action = null;
      const userScopeEntity = new UserScopeEntity(
        props?.userData?.id,
        scope?.id, // added ?
        role
      );
      if (props.isEditMode || isRoleAlreadyExist(scope)) {
        action = userScopesActionsService.updateUserScopeRole(userScopeEntity);
      } else {
        action = userScopesActionsService.addUserScopeRole(userScopeEntity);
      }

      action.then((response) => {
        store.dispatch(commonActions.closeSideModal());
        if (response.data.isSuccess) {
          store.dispatch(userActions.updateGmtUserScope(response.data));
          showUpdateSuccessMessage();
          //store.dispatch(userActions.setShowUserInfoWindow(false));
        } else {
          showErrorMessage(response.data?.error);
          store.dispatch(commonActions.setIsShowLoadingSpinner(false));
        }
      }).catch(error => {
        store.dispatch(commonActions.setIsShowLoadingSpinner(false));        
      });
    }
  };
  return (
    <form name="AddPermissionsForm" onSubmit={handleSubmit}>
      <div className={classes.formContainer}>
        <UserRoleStep
          isEditMode={props.isEditMode}
          currentStep={stateData.currentStep}
          handleChange={handleChange}
          handleCurrentStepValidity={handleCurrentStepValidity}
          {...formData}
        />
      </div>
      <div className={classes.next}>
        <EllipseButton disabled={formData?.scopesList?.length === 0} type="submit">{Strings.SAVE_CHANGES}</EllipseButton>
      </div>
    </form>
  );
};

export default AddPermissionsForm;
